import { Formik } from "formik";
import { useEffect, useState } from "react";
import { BeatLoader } from "react-spinners";
import DropzoneComponent from "./DropzoneComponent";

const StepSix = ({step, submitLoading, nextStep, prevStep, handleFormData, values , setFormData}) => {
    
    const [signature_url, setSignatureUrl] = useState(null);
	const [signature_file, setSignatureFile] = useState(null);
    const [files, setFiles] = useState([]);

    const convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
		  const fileReader = new FileReader();
		  fileReader.readAsDataURL(file)
		  fileReader.onload = () => {
			resolve(fileReader.result);
		  }
		  fileReader.onerror = (error) => {
			reject(error);
		  }
		})
	  }

	const handleFileRead = async (event) => {
		const file = event.currentTarget.files[0];
		const base64 = await convertBase64(file);
		setSignatureUrl(base64); 
		setSignatureFile(base64);
	  }

        return (
        <div>
            <div className="border-b-2 py-4">
					<div className="uppercase tracking-wide text-xs font-bold text-gray-500 mb-1 leading-tight">{`Step: ${step} of 6`}</div>
					<div className="flex flex-col md:flex-row md:items-center md:justify-between">
						<div className="flex-1">
							<div>
								<div className="text-md font-bold text-gray-800 leading-tight">Reference</div>
							</div>
						</div>

						<div className="flex items-center ml-4 md:w-64">
							<div className="w-full bg-white rounded-full mr-2">
								<div className="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white" style={{ width: '100%' }}></div>
							</div>
							<div className="text-xs w-10 text-gray-600">100%</div>
						</div>
					</div>
            </div>
            <Formik
			initialValues={{ 
				ref1_company_name: "",
                ref1_person_charge: "",
                ref1_telphone_number: "",
                ref2_company_name: "",
                ref2_person_charge: "",
                ref2_telphone_number: "",
                application_date: "",
                applicant_signature: "",
                received_by: "",
                approved_by: "",
                remark: "",
                terms: ""
			}}
        validate={values => {
            const errors = {};
            if(values.terms.length == 0){
                errors.terms = 'Please accept terms of service'
            }

            return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
            try{	

            const formData  = new FormData();
            if(values)
            {
            Object.keys(values).map((item, i) => {
                formData.append(item, values[item]);
            });
            }

            formData.append('signature', signature_file);

            let fromSix = {...values, signature: signature_file, documents: files};
            setFormData(prevState => ({
                ...prevState,
                fromSix
                }));
            handleFormData({...values, signature: signature_file, documents: files});
            setSubmitting(false);
            nextStep();
            }catch(e){
                console.log(e)
            }
        }}
        >
        {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
        }) => (
	    <form onSubmit={handleSubmit}>
            <div className="py-10">
            <div className="mb-5">
                    <h4 className="font-bold mb-1 text-gray-800">Reference 1 :</h4>
                    <hr className="mb-4"/>
                <div className="mb-5">
                    <label for="company_name" className="font-bold mb-1 text-sm text-gray-800 block">Company Name</label>
                    <input type="text"
                        name='ref1_company_name'
                        id='ref1_company_name'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ref1_company_name}
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        placeholder="Enter Company Name"/>
                </div>
                <div className="mb-5">
                    <label for="company_name" className="font-bold mb-1 text-sm text-gray-800 block">Person in Charge</label>
                    <input type="text"
                        name='ref1_person_charge'
                        id='ref1_person_charge'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ref1_person_charge}
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        placeholder="Enter Person in Charge"/>
                </div>
                <div className="mb-5">
                    <label for="company_name" className="font-bold mb-1 text-sm text-gray-800 block">Telephone Number</label>
                    <input type="text"
                        name='ref1_telphone_number'
                        id='ref1_telphone_number'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ref1_telphone_number}
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        placeholder="Enter Telephone Number"/>
                </div>
                </div>

                <div className="mt-5 mb-5 pt-5">
                <h4 className="font-bold mb-1 text-gray-800">Reference 2 :</h4>
                <hr className="mb-4"/>

                <div className="mb-5">
                    <label for="company_name" className="font-bold mb-1 text-sm text-gray-800 block">Company Name</label>
                    <input type="text"
                        name='ref2_company_name'
                        id='ref2_company_name'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ref2_company_name}
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        placeholder="Enter Company Name"/>
                </div>
                <div className="mb-5">
                    <label for="company_name" className="font-bold mb-1 text-sm text-gray-800 block">Person in Charge</label>
                    <input type="text"
                        name='ref2_person_charge'
                        id='ref2_person_charge'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ref2_person_charge}
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        placeholder="Enter Person in Charge"/>
                </div>
                <div className="mb-5">
                    <label for="company_name" className="font-bold mb-1 text-sm text-gray-800 block">Telephone Number</label>
                    <input type="text"
                        name='ref2_telphone_number'
                        id='ref2_telphone_number'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ref2_telphone_number}
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        placeholder="Enter Telephone Number"/>
                </div>
                </div>
                <hr />
                <div className="mb-5 mt-5 pt-5">
                <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-1 sm:col-span-1">
                            <div className="mb-5">
                                <label for="application_date" className="font-bold mb-1 text-sm text-gray-800 block"> Application Date</label>
                                <input type="date"
                                    name='application_date'
                                    id='application_date'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.application_date}
                                    className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                    placeholder="Enter application date..."/>
                            </div>
                        </div>
                        <div className="col-span-1 sm:col-span-1">
                            <div className="mb-5">
                                <label for="issue_date_on" className="font-bold mb-1 text-sm text-gray-800 block">Received By</label>
                                <input type="text"
                                    name='received_by'
                                    id='received_by'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.received_by}
                                    className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                    placeholder="Enter received by..."/>
                            </div>
                        </div>
                        <div className="col-span-1 sm:col-span-1">
                            <div className="mb-5">
                                <label for="approved_by" className="font-bold mb-1 text-sm text-gray-800 block">Approved By</label>
                                <input type="text"
                                    name='approved_by'
                                    id='approved_by'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.approved_by}
                                    className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                    placeholder="Enter approved by..."/>
                            </div>
                        </div>
                        <div className="col-span-1 sm:col-span-1">
                            <div className="mb-5">
                            <label for="approved_by" className="font-bold mb-1 text-sm text-gray-800 block">Your Signature</label>
                            <div class="max-w-xl">
                            <label
                                class="flex justify-center w-full h-15 px-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                                    {signature_url ?
                                    <img src={signature_url} className="object-cover w-full" />
                                    :
                                    <span class="flex items-center space-x-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                    </svg>
                                    <span class="text-sm text-gray-600">
                                        Drop files to Attach Signature, or
                                        <span class="text-blue-600 underline">browse</span>
                                    </span>
                                    </span>}
                                <input name="signature" onChange={(event) => { handleFileRead(event); }} id="signature" accept="image/*" className="hidden" type="file" />
                            </label>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-5">
                    <label for="remark" className="font-bold mb-1 text-sm text-gray-800 block">Remark</label>
                    <textarea
                        className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                        name="remark"
                        id='remark'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.remark}
                        placeholder="Enter your remark..."></textarea>
                </div>

                <div className="mb-5">
                <label for="remark" className="font-bold mb-1 text-sm text-gray-800 block">Attach Documents</label> 
                <DropzoneComponent setFiles={setFiles} files={files}/>
                </div>

                <div className="mb-5">
                    <label className="font-bold mb-1 text-sm text-gray-800 block">Declaration: </label>
                    <p>I solemnly hereby declare that</p>
                    <li className="list-none ml-4">1. Application which has been submitted by me is on my own free will.</li>
                    <li className="list-none ml-4">2.  I have not approached or directed by any agent what so ever or other means of source for getting this job opportunity/employment with HERMES SHIP MANAGEMENT PVT LTD.</li>
                    <li className="list-none ml-4">3. I have not paid any service charges vide cash/ cheque/ any kind to anyone for placement or seeking for with HERMES SHIP MANAGEMENT PVT LTD.</li>
                </div>

                <div className="mb-5">
                    <label className="flex justify-start items-center text-truncate pt-4">
                    <div className="text-teal-600 mr-3">
                        <input type="checkbox" 
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value="1" className="form-checkbox border border-gray-500 focus:outline-none focus:shadow-outline" name="terms" id='terms'/>
                    </div>
                    <div className="select-none text-gray-700">I accept the Terms of Service.</div>
                    </label>
                    <span class="text-sm text-red-600">{errors.terms && touched.terms && errors.terms}</span>
                </div>

            </div>

            <div className=" bottom-0 left-0 right-0 py-5">
			<div className="max-w-3xl mx-auto px-4">
				<div className="flex justify-between">

                    <div className="w-1/2">
						<button
                            onClick={()=> prevStep() }
							className="w-32 focus:outline-none py-2 px-5 rounded-md shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium text-gray-800 text-sm border" 
						>Previous</button>
					</div>

					<div className="w-1/2 text-right">
						<button
							type="submit"
                            disabled={submitLoading}
							className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-md shadow-sm text-center text-white bg-orange-500 hover:bg-orange-600 font-medium text-sm" 
						>{!submitLoading ? 'Complete' : <BeatLoader size={10} color="#fff" /> }</button>
					</div>
				</div>
			</div>
            </div>
        </form>)}
        </Formik>
        </div>
    )
}

export default StepSix;